import { render, staticRenderFns } from "./PostChallengeInteract.vue?vue&type=template&id=3bdccb99&scoped=true"
import script from "./PostChallengeInteract.vue?vue&type=script&lang=js"
export * from "./PostChallengeInteract.vue?vue&type=script&lang=js"
import style0 from "./PostChallengeInteract.vue?vue&type=style&index=0&id=3bdccb99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdccb99",
  null
  
)

export default component.exports